import { SOCIAL_LINKS } from "@/data/networks";

export const FollowButton = ({ network, variant = "light", testId }) => {
  const { Icon } = network;
  const base = "group inline-flex items-center gap-2 rounded-full h-12 px-6 text-sm font-medium border transition-colors duration-300";
  const style = variant === "dark"
    ? "border-[#FBF8F4]/25 text-[#FBF8F4] hover:bg-[#FBF8F4] hover:text-[#181412]"
    : "border-[#E8DDD3] bg-white text-[#1F1A17] hover:border-[#1F1A17]";
  return (
    <a
      href={SOCIAL_LINKS[network.key]}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId || `follow-${network.key}-btn`}
      className={`${base} ${style}`}
    >
      <Icon className="h-4 w-4 transition-transform duration-300 group-hover:scale-110" style={{ color: variant === "dark" ? undefined : network.accent }} />
      Follow on {network.name}
    </a>
  );
};
